module.exports = __webpack_public_path__ + "img/plan-01.89f81b83.png";